import { useEffect, useState } from "react";
import StorylineServerProxy from "../storyline-proxy/storyline-proxy";
import { Button, Checkbox, MenuItem, Paper, Select, TextField } from "@mui/material";

export function DigestGenerator(){

    const [storyElements, setStoryElements] = useState([] as any[]);
    const [selectedIndexes, setSelectedIndexes] = useState([] as any[]);

    useEffect(() => {
        StorylineServerProxy.getStoryElements(50, 0).then(elements => setStoryElements(elements));
    }, []);



    function handleCheckboxClicked(index, checked){
        let newSelectedIndexes = [];
        if(checked){
            newSelectedIndexes = [... selectedIndexes];
            newSelectedIndexes.push(index);
        }
        else{
            for(const current of selectedIndexes){
                if(current != index){
                    newSelectedIndexes.push(current);
                }
            }
        }

        setSelectedIndexes(newSelectedIndexes);
    }
    
    function copyToClipboard(){
        let text = "";
        selectedIndexes.map(index => {
            text += storyElements[index].title + ": " + storyElements[index].link + "\n";
        });

        navigator.clipboard.writeText(text);
    }

    useEffect(() => {
        const today = new Date().toISOString().substring(0, 10);
        let index = 0;
        const newSelectedIndexes = [];
        for(const storyElement of storyElements){
            console.log(storyElement.timestampFormatted);
            if(storyElement.timestampFormatted == today){
                newSelectedIndexes.push(index);
            }
            index++;
        }

        setSelectedIndexes(newSelectedIndexes);
    }, [storyElements]);
    
    useEffect(() => {
        copyToClipboard()
    }, [selectedIndexes]);

    return <>
        <Paper elevation={4} sx={{ padding: 3}}>
            {
                storyElements.map((storyElement, index) => {
                    return <>
                        <Checkbox checked={selectedIndexes.includes(index)} onChange={event => {handleCheckboxClicked(index, event?.target.checked)}}></Checkbox>{ storyElement.timestampFormatted } - {storyElement.title}<br />                        
                        <br />
                    </>
                })
            }
        </Paper>
        <Paper elevation={4} sx={{ padding: 3}}>
            {
                selectedIndexes.map(index => {
                    return <>{ storyElements[index].title }: { storyElements[index].link } <br /></>
                }) 
            }
        </Paper>
        <Button onClick={copyToClipboard}>Copy to clipboard</Button>
    </>
}